export async function checkAuth() {
  const token = localStorage.getItem("auth_token");
  const role = localStorage.getItem("user_role");

  if (!token) return { isAuthenticated: false, role: null };

  // token exists but role missing -> treat as not authenticated and clean up
  if (!role) {
    localStorage.removeItem("auth_token");
    return { isAuthenticated: false, role: null };
  }

  return { isAuthenticated: true, role };
}
